// localStorage 사용
const _localStorage =
  typeof window !== 'undefined' && typeof window.localStorage === 'object'
    ? window.localStorage
    : {}

// sessionStorage 사용
const _sessionStorage =
  typeof window !== 'undefined' && typeof window.sessionStorage === 'object'
    ? window.sessionStorage
    : {}

export const keys = {
  // 아이디 저장 체크 시 localStorage에 저장
  id: '__infostock_id__',
  // 최근 접근 경로
  pathInfo: '__infostock_pathInfo__',
  // 로그인/권한 체크 전 이전 경로
  beforePath: '__infostock_before_path__',
  // 네이버 로그인 복귀 처리 등에 사용하는 임시 체크 값
  check: '__infostock_check__',
  token: '__infostock_token__',
  count: '__infostock_count__',
}
// 브라우저를 닫거나 탭 세션이 끝나면 사라져도 되는 임시 값들
const SESSION_KEYS = new Set([
  keys.pathInfo,
  keys.beforePath,
  keys.check,
  keys.count,
])
// key에 따라 localStorage 또는 sessionStorage 선택
function getStorageByKey(key) {
  return SESSION_KEYS.has(key) ? _sessionStorage : _localStorage
}

const storage = {
  set(key, value) {
    const target = getStorageByKey(key)
    target[key] = JSON.stringify(value)
  },

  get(key) {
    const target = getStorageByKey(key)
    if (!target[key]) return null

    try {
      return JSON.parse(target[key])
    } catch (e) {
      return target[key]
    }
  },
  // 특정 storage 삭제
  remove(key) {
    const localExists = typeof _localStorage.removeItem === 'function'
    const sessionExists = typeof _sessionStorage.removeItem === 'function'

    if (localExists) _localStorage.removeItem(key)
    else delete _localStorage[key]

    if (sessionExists) _sessionStorage.removeItem(key)
    else delete _sessionStorage[key]
  },
  // 전체 storage 초기화
  clear() {
    if (typeof _localStorage.clear === 'function') _localStorage.clear()
    if (typeof _sessionStorage.clear === 'function') _sessionStorage.clear()
  },
}

export default storage